import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Dashboard } from "./Dashboard";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "CALENDAR",
    applicationRights: Rights,
    title: 'Kalender',
    text: 'Kalender',
    icon: 'calendar-dots',
    url: "/calendar",
    sequenceNo: 13000,
    routes: Routes,
    dashboard: Dashboard
})
